import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AttachmentList from '@/components/attachmentList/index.vue';
import SubSelect from './subSelect.vue';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loadingStatus = false;
    _this.complianceOfficerList = [];
    _this.indeterminate = false;
    _this.checkAll = false;
    _this.checkedList = [];
    _this.formData = {
      data: [],
      batchIdList: []
    };
    _this.formDataRule = {
      'data.*._compliance_officer_id': [{
        required: true,
        type: 'array',
        message: _this.t('请选择合规负责人'),
        trigger: 'change'
      }]
    };
    return _this;
  }

  Object.defineProperty(AddEditModal.prototype, "filterComplianceOfficerList", {
    get: function get() {
      var _this = this;

      if (this.parentData.isGB === undefined) {
        return [];
      }

      if (this.parentData.isGB) {
        return this.complianceOfficerList.filter(function (item) {
          return item.country_code === _this.$enum.common.CountryEnum.GB;
        });
      } else {
        return this.complianceOfficerList.filter(function (item) {
          return item.country_code !== _this.$enum.common.CountryEnum.GB;
        });
      }
    },
    enumerable: false,
    configurable: true
  });

  AddEditModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddEditModal.prototype.initFormData = function () {
    var data = this.parentData.list.map(function (item) {
      var _a;

      var ids = ((_a = item.current_compliance_officer) === null || _a === void 0 ? void 0 : _a.length) ? [item.current_compliance_officer[0].id] : [];
      return {
        compliance_officer_id_list: ids,
        _compliance_officer_id: ids[0],
        id: item.id,
        product_eu_uk_type: item.product_eu_uk_type,
        product_sku: item.product_sku,
        import_country: item.import_country,
        import_country_name: item.import_country_name
      };
    });
    return data;
  };

  AddEditModal.prototype.queryComplianceOfficerList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.queryComplianceOfficerAll({
              status: this.$enum.product.ComplianceOfficerStatusEnum.AUDIT_PASSED
            })];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.complianceOfficerList = res.data.list;
            }

            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.handleCheckedChange = function (checkedList) {
    this.indeterminate = !!checkedList.length && checkedList.length < this.formData.data.length;
    this.checkAll = checkedList.length === this.formData.data.length;
  };

  AddEditModal.prototype.handleCheckAllChange = function (e) {
    var el = e.target;
    var checked = el.checked;
    Object.assign(this, {
      checkedList: el.checked ? this.$util.deepCopy(this.formData.data.map(function (item) {
        return item.product_sku;
      })) : [],
      indeterminate: false,
      checkAll: el.checked
    });
  };

  AddEditModal.prototype.handleBatchIdListChange = function (value) {
    var _this = this;

    var hasChecked = this.checkedList.length ? true : false;
    this.formData.data.forEach(function (item) {
      if (!hasChecked) {
        item.compliance_officer_id_list = value;
      } else if (_this.checkedList.includes(item.product_sku)) {
        item.compliance_officer_id_list = value;
      }
    });
  };

  AddEditModal.prototype.handleOk = function () {
    return __awaiter(this, void 0, void 0, function () {
      var formDataRef;

      var _this = this;

      return __generator(this, function (_a) {
        formDataRef = this.$refs.formDataRef;
        formDataRef.validate(function (valid) {
          return __awaiter(_this, void 0, Promise, function () {
            var formData, res;

            var _this = this;

            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!valid) {
                    return [2];
                  }

                  formData = this.$util.deepCopy(this.formData);
                  formData.data.forEach(function (item) {
                    item.compliance_officer_id_list = !_this.$util.isEmpty(item._compliance_officer_id) ? [item._compliance_officer_id] : [];
                  });
                  return [4, this.$api.product.updateMaintenanceComplianceOfficer({
                    list: formData.data
                  })];

                case 1:
                  res = _a.sent();

                  if (res.code === 0) {
                    this.$message.success($t("\u64CD\u4F5C\u6210\u529F"));
                    this.$emit('success');
                    this.handleClose();
                  }

                  return [2];
              }
            });
          });
        });
        return [2];
      });
    });
  };

  AddEditModal.prototype.created = function () {};

  AddEditModal.prototype.handleVisibleChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef;

      var _this = this;

      return __generator(this, function (_a) {
        this.queryComplianceOfficerList();

        if (value) {
          this.formData.data = [];

          if (this.parentData.list.length <= 20) {
            this.formData.data = this.initFormData();
          } else {
            this.loadingStatus = true;
            setTimeout(function () {
              _this.formData.data = _this.initFormData();
              _this.loadingStatus = false;
            }, 300);
          }
        } else {
          this.checkedList = [];
          this.formData.batchIdList = [];
          formDataRef = this.$refs.formDataRef;
          formDataRef && formDataRef.clearValidate();
        }

        return [2];
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": false
  })], AddEditModal.prototype, "parentData", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddEditModal.prototype, "visible", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], AddEditModal.prototype, "handleVisibleChange", null);

  AddEditModal = __decorate([Component({
    components: {
      AttachmentList: AttachmentList,
      SubSelect: SubSelect
    }
  })], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;